module.exports = __webpack_public_path__ + "static/ben-goldacre-d67b6261a51839a91e0950da4c064dd9.jpg";